import React from 'react';
import Container from '@material-ui/core/Container';

import './footer.scss';

function Footer() {
    return (
        <footer className="footer">
            <Container>Footer</Container>
        </footer>
    );
}

export { Footer };
